import { render, staticRenderFns } from "./ItemNameField.vue?vue&type=template&id=74c005b2&scoped=true&"
import script from "./ItemNameField.vue?vue&type=script&lang=js&"
export * from "./ItemNameField.vue?vue&type=script&lang=js&"
import style0 from "./ItemNameField.vue?vue&type=style&index=0&id=74c005b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c005b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
